import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layout/Layout';
import ManuscriptList from './Components/ManuscriptList';
import ManuscriptMetadata from './Components/ManuscriptMetadata';
import ManuscriptViewer from './Components/ManuscriptViewer';
import Practice from './Components/Practice';
import About from './Layout/About';
import { ManuscriptProvider } from './Components/ManuscriptContext';
import './App.css';

const App = () => {
  return (
    <Router>
      <ManuscriptProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<ManuscriptList />} />
            <Route path="/manuscript/:id" element={<ManuscriptMetadata />} />
            <Route path="/viewer/:id" element={<ManuscriptViewer />} />
            <Route path="/viewer/:id/:folioId" element={<ManuscriptViewer />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/practice/:id" element={<Practice />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Layout>
      </ManuscriptProvider>
    </Router>
  );
};

export default App;